export default "__VITE_ASSET__D3Y2REiI__"